import { createCrudActions } from '../utils/crudGenerator';

const formatResponsibles = (data) => {
    if (!data) {
        return [];
    }
    const formatItem = (item) => ({
        ...item,
        label: `${item.name}`,
        value: item._id,
    });

    if (Array.isArray(data)) {
        return data.map(formatItem);
    }
    return formatItem(data);
};

export const {
    fetch: fetchResponsibles,
    create: createResponsible,
    update: updateResponsible,
    delete: deleteResponsibles
} = createCrudActions('RESPONSIBLE', "Responsable", formatResponsibles);